export const normalizeStoreSearchQuery = (value: unknown) => {
  if (typeof value !== "string") {
    return undefined
  }

  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : undefined
}

export const applyStoreSearchQuery = <T extends Record<string, unknown>>(
  queryParams: T,
  value: unknown,
) => {
  const q = normalizeStoreSearchQuery(value)
  return q ? { ...queryParams, q } : queryParams
}
